import {Typography} from '@mui/material';
import Grid from '@mui/material/Grid';

import {FONT_FAMILIES, PRODUCTS_BILLING_INTERVALS, PRODUCTS_BILLING_SCHEMES} from '../../../../../const';
import usePayment from '../../../../../hooks/providers/usePayment';
import {productShape} from '../../../../../proptypes-shapes';
import {calculateAverageProductPrice, calculateProductPrice, getHumanReadablePrice} from '../../../../../utils/payment';
import ProductPricingInformation from '../ProductPricingInformation/ProductPricingInformation';

const ProductPrice = ({product}) => {
  const {getCartProduct} = usePayment();
  const cartProduct = getCartProduct(product.id);
  const productQuantity = cartProduct?.quantity || 0;

  const averagePrice = calculateAverageProductPrice(product, productQuantity);
  const rawProductPrice = calculateProductPrice(product, productQuantity);
  const humanReadablePrice = getHumanReadablePrice(rawProductPrice);

  const shouldDisplayPricingInformation = product.billing_scheme === PRODUCTS_BILLING_SCHEMES.TIERED;

  return (
    <Grid item xs={6} sm={4} lg={2.5} pl={2} mt={{xs: 2, sm: 0}}>
      <Typography fontSize={{xs: 30, sm: 35}} fontFamily={FONT_FAMILIES.TITLE} lineHeight={1.1}>
        {humanReadablePrice} €
      </Typography>

      {productQuantity > 0 && product.billing_scheme === PRODUCTS_BILLING_SCHEMES.TIERED ? (
        <Typography fontSize={12} color="text.secondary">
          Soit {averagePrice}€{' '}
          <span
            style={{
              marginLeft: '-2px',
              verticalAlign: 'top',
              fontSize: '8px'
            }}
          >
            HT
          </span>{' '}
          / unité
        </Typography>
      ) : null}

      <Grid container alignItems="center">
        {product.interval === PRODUCTS_BILLING_INTERVALS.MONTH ? (
          <Grid item>
            <Typography fontSize={12} fontFamily={FONT_FAMILIES.TITLE}>
              par mois HT
            </Typography>
          </Grid>
        ) : null}

        {productQuantity > 0 && shouldDisplayPricingInformation ? <ProductPricingInformation quantity={productQuantity} product={product} /> : null}
      </Grid>
    </Grid>
  );
};

ProductPrice.propTypes = {
  product: productShape.isRequired
};

export default ProductPrice;
